import { GridColDef } from '@mui/x-data-grid';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import IconAction from '#app/Component/IconAction';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import { momentDateFormatter } from '#app/Util/MomentDateFormatter';
import { Filters } from '#app/View/Sale/Client/SaleClientList';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { ChannelClient, ChannelClientTranslations } from '#app/typings/channelClient';
import { ClientList } from '#app/typings/client';

type Props = Omit<ReturnType<typeof useCollectionPaginated<ClientList, Filters>>, 'setFilters' | 'filters'>;

const List: React.FC<Props> = ({
  data: clients,
  totalItems,
  loading,
  pagination,
  sorting,
  setPagination,
  setSorting,
}) => {
  const columns: GridColDef[] = [
    {
      field: 'number',
      headerName: 'Référence',
      minWidth: 150,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 2,
    },
    {
      field: 'firstname',
      headerName: 'Prénom',
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'lastname',
      headerName: 'Nom',
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'zipCode',
      headerName: 'Code postal',
    },
    {
      field: 'channelClient',
      headerName: 'Canal',
      valueGetter: (value: ChannelClient) => ChannelClientTranslations[value],
      minWidth: 180,
    },
    {
      field: 'createdAt',
      headerName: 'Date de création',
      valueGetter: (value: string) => momentDateFormatter.dateTimeToFormatFr(value),
      minWidth: 130,
    },
    {
      field: 'action',
      headerName: 'Action',
      type: 'actions',
      getActions: ({ row }) => [
        <IconAction title="Visualiser" icon="view" to={getRoutePathname('sale_client', { uuid: row.uuid })} />,
      ],
    },
  ];

  return (
    <DataGrid
      rows={transformObjectToDataGridRowsArray<ClientList>(clients)}
      columns={columns}
      loading={loading}
      rowCount={totalItems}
      setSorting={setSorting}
      setPagination={setPagination}
      pagination={pagination}
      sorting={sorting}
    />
  );
};

export default List;
